import FieldEditor from "editor/FieldEditor";
import ContentAdminEditor from "content/adminEditors/ContentAdminEditor";


class ContentAdminEditorDateTime extends ContentAdminEditor {

    static get_name() {
        return 'DateTime Input';
    }

    getInputType() {
        return '14';
    }

    /**
     * @abstract
     * @return Array
     */
    getSettingsOptions() {
        return [
            {
                name: 'slug',
                label: 'Slug',
                type: 'text'
            }
        ];
    }

}

FieldEditor.register_editor('content/admin/datetime', ContentAdminEditorDateTime);

export default ContentAdminEditorDateTime;
